import log from '@diplodoc/transform/lib/log';
import yfmPlugin from '@diplodoc/transform/lib/plugins/cut';
import { CutNode } from './const';
import { fromYfm } from './fromYfm';
import { getSpec } from './spec';
import { toYfm } from './toYfm';
export { CutNode, cutType, cutTitleType, cutContentType } from './const';
export const YfmCutSpecs = (builder, opts) => {
    const spec = getSpec(opts, builder.context.get('placeholder'));
    builder
        .configureMd((md) => md.use(yfmPlugin, { log }))
        .addNode(CutNode.Cut, () => ({
        spec: spec[CutNode.Cut],
        toYfm: toYfm[CutNode.Cut],
        fromYfm: {
            tokenSpec: fromYfm[CutNode.Cut],
        },
        view: opts.cutView,
    }))
        .addNode(CutNode.CutTitle, () => ({
        spec: spec[CutNode.CutTitle],
        toYfm: toYfm[CutNode.CutTitle],
        fromYfm: {
            tokenSpec: fromYfm[CutNode.CutTitle],
        },
        view: opts.cutTitleView,
    }))
        .addNode(CutNode.CutContent, () => ({
        spec: spec[CutNode.CutContent],
        toYfm: toYfm[CutNode.CutContent],
        fromYfm: {
            tokenSpec: fromYfm[CutNode.CutContent],
        },
        view: opts.cutContentView,
    }));
};
